<template>
  <div v-if="visible" class="custom-centered-modal">
    <div class="modal-dialog modal-sm modal-dialog-centered">
      <div class="modal-content">

        <div class="modal-header">
          <button type="button" class="close" @click="close">&times;</button>
          <h4 class="modal-title text-center">{{ title }}</h4>
        </div>

        <div class="modal-body">
          <div class='col-lg-6 col-sm-6' style="padding: 0px;margin:0px">
          <div class="form-group input-group">
            <span class="input-group-addon">المبلغ</span>
            <input
              class="form-control"
              type="text"
              v-model="local.amount"
              @keypress="isNumber"
            >
          </div>
        </div>
        <div class='col-lg-6 col-sm-6' style="padding: 0px;margin:0px">
        <div class="form-group input-group">
          <span class="input-group-addon">المسدد</span>
          <input
            class="form-control"
            type="text"
            v-model="local.paid"
            disabled
          >
        </div>
      </div>
          <div class="form-group input-group">
            <span class="input-group-addon">تاريخ الاستحقاق</span>
            <Datepicker
              :typeable="true"
              :format="customFormatter"
              :language="ar"
              :bootstrap-styling="true"
              v-model="local.due_date"
            />
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn btn-outline btn-sm btn-success" @click="save">
            {{btnTitle}}
          </button>
          <button class="btn btn-outline btn-sm btn-default" @click="close">
            إغلاق
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import Swal from 'sweetalert2'
export default {
  name: 'AddInstallmentModal',
  components: { Datepicker },
  props: {
    visible: Boolean,
    record: Object,
    installments: {
      type: Array,
      default: () => []
    },
    ar: Object,
    customFormatter: Function
  },
  data () {
    return {
      local: {
        uid: null,
        amount: '',
        due_date: '',
        paid: ''
      }
    }
  },
  watch: {
    visible (val) {
      if (val && this.record) {
        this.local = {
          uid: this.record.uid || null,
          amount: this.record.amount || '',
          paid: this.record.paid || 0,
          due_date: this.record.due_date || ''
        }
      }
    }
  },
  methods: {
    // ====================================================
    close () {
      this.$emit('close')
    },
    // ====================================================
    save () {
      // شرط المبلغ ≥ المدفوع
      if (Number(this.local.amount) < Number(this.local.paid)) {
        Swal.fire({
          icon: 'error',
          title: 'خطأ في المبلغ',
          text: 'المبلغ لا يمكن أن يكون أقل من المدفوع',
          confirmButtonText: 'تمام'
        })
        return
      }
      if (!this.local.due_date) {
        Swal.fire({
          icon: 'error',
          title: 'خطأ',
          text: 'يجب إدخال تاريخ الاستحقاق'
        })
        return
      }
      const dueDate = moment(this.local.due_date).format('YYYY-MM-DD')
      // التحقق من تكرار التاريخ
      const exists = this.installments.some(inst => {
        if (inst.state === 'deleted') return false
        if (inst.uid === this.local.uid) return false // تجاهل القسط الجاري تعديله
        return inst.due_date === dueDate
      })
      if (exists) {
        Swal.fire({
          icon: 'error',
          title: 'خطأ',
          text: 'هذا التاريخ موجود بالفعل في الأقساط',
          confirmButtonText: 'تمام'
        })
        return
      }
      // إرسال البيانات للأب
      this.$emit('save', {
        uid: this.local.uid,
        amount: Number(this.local.amount),
        paid: Number(this.local.paid),
        due_date: dueDate
      })
      this.close()
    },
    // ====================================================
    isNumber (evt) {
      const c = evt.which ? evt.which : evt.keyCode
      if ((c > 31 && (c < 48 || c > 57)) && c !== 46) {
        evt.preventDefault()
      }
    }
    // ====================================================
  },
  computed: {
    title () {
      return this.local.uid === -1 ? 'إضافة قسط' : 'تعديل قسط'
    },
    btnTitle () {
      return this.local.uid === -1 ? 'إضافة' : 'حفظ'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/Customers/contractModale/AddInstallmentModal.vue